<!--
 * @Descripttion: 
 * @version: 
 * @Author: wanglikun
 * @Date: 2022-06-01 08:28:56
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-07-11 09:53:19
-->
<template>
  <LayoutSider :style="{ overflow: 'auto', height: 'calc(100vh - 64px)' }" v-model:collapsed="collapsed" width="200px">
    <slot></slot>
  </LayoutSider>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { LayoutSider } from 'ant-design-vue'
  import { useSettingStore } from '@jms/store/sysSetting'
  const settingStore = useSettingStore()

  const collapsed = computed(() => {
    return settingStore.getCollapsed
  })
</script>

<style lang="less" scoped>
  .logo {
    margin-top: 10px;
    margin-left: 20px;
    img {
      width: 30px;
      height: 32px;
      margin-right: 8px;
    }
    .name {
      color: #fff;
      font-size: 16px;
    }
  }
  .describe {
    color: #fff;
    margin-left: 20px;
  }
  .collapsed {
    width: 50px;
    margin: 10px 0px;
    margin-left: 10px;
  }
</style>
